const IssueStatusDescEnum = Object.freeze({
  0: 'przyjęte',
  1: 'w trakcie',
  2: 'rozwiązane'
});

export default IssueStatusDescEnum;
